import container from '@ioc';
import { holdingsApiThunkPayload } from '../../constants';
import { GetHoldingsRequest } from './types';
import { IAuthenticationService, ILoggingService, MultiPortfolioHoldingList, PortfoliosServiceClient } from 'clientportalshared';
import { IAuthenticationService$ } from '@services/auth/IAuthentication.interface';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ILoggingService$ } from '@services/logging/ILoggingService.interface';
import appConfig from '@src/app/config/appConfig';
import { getAustralianDate } from '@src/app/utils/GenericUtils';

export const getHoldingsAsync = createAsyncThunk<MultiPortfolioHoldingList, GetHoldingsRequest>(
  holdingsApiThunkPayload,
  async (payload: GetHoldingsRequest) => {
    try {
      const authService = container.get<IAuthenticationService>(IAuthenticationService$);
      const loggingService = container.get<ILoggingService>(ILoggingService$);
      const portfoliosClient = new PortfoliosServiceClient(appConfig.apiEndpointUrl, authService, loggingService, appConfig);
      const result = await portfoliosClient.getMultiPortfolioHoldingsAsync(getAustralianDate(payload.asOfDate), payload.clientPortfolios);
      if (payload.securityCode) {
        const response: MultiPortfolioHoldingList = {
          totalValue: result.totalValue,
          holdingList: {
            asOfDate: result.holdingList?.asOfDate,
            data: result.holdingList?.data?.filter((holding) => holding.securityCode === payload.securityCode),
          },
        };
        return response;
      }
      return result;
    } catch (e) {
      return {} as MultiPortfolioHoldingList;
    }
  }
);
